import { render } from "./UserSection.vue?vue&type=template&id=6c2eb562"
import script from "./UserSection.vue?vue&type=script&lang=js"
export * from "./UserSection.vue?vue&type=script&lang=js"

import "./UserSection.vue?vue&type=style&index=0&id=6c2eb562&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__